<template>
  <div class="question-container" :class="device.isMobile ? 'question-container-mobile' : ''">
    <!-- <div class="question-title">{{ content.title }}</div> -->
    <div class="reset" @click.stop="reset"></div>
    <div class="question-content">
      <div v-for="(topicContent, topicIndex) in content.content" :key="topicContent.key" v-show="activeTopic === topicIndex">
        <div class="question-top">
          <div class="question-top-title" v-if="topicContent.ps_title">
            {{ topicContent.ps_title }}
          </div>
          <div class="question-top-info" v-if="topicContent.ps_info">
            {{ topicContent.ps_info }}
          </div>
        </div>
        <audio
          :src="topicContent.audiofile"
          controls
          v-if="topicContent.audiofile"
        ></audio>
        <div class="answer-r-b-subjectC">
          <!-- 单选题&判断题start -->
          <div v-if="topicContent.type_id == 1 || topicContent.type_id == 7">
            <p
              class="subject-info"
              :class="topicContent.topic_sub[0].isExample ? 'subject-info-example' : ''"
              v-html="topicContent.topic_sub[0].subinfo"
            ></p>
            <div
              v-if="anwserVisible"
              class="isTrue"
              :class="historyData && historyData[topicContent.topic_sub[0].key] == topicContent.topic_sub[0].answer ? 'true-icon' : 'false-icon'"
            ></div>
            <el-radio-group
              v-model="topicContent.topic_sub[0].user_answer"
              @change="changeHandle"
            >
              <el-radio
                :label="item.answer_id"
                v-for="(item, index) in topicContent.topic_sub[0].topic_answer"
                :key="index"
                :class="anwserVisible && item.answer == 1 ? 'true-active' : ''"
                :disabled="!!(historyData && historyData[topicContent.topic_sub[0].key])"
                ><span v-html="item.ask"></span
              ></el-radio>
            </el-radio-group>
            <div class="anwser-box" v-if="anwserVisible">
              <div>参考答案：{{ anwserContent.concat_answer }}</div>
              <div v-html="anwserContent.subanalysis"></div>
            </div>
          </div>
          <!-- 单选题&判断题 end -->
          <!-- 多选题&不定项选择题 start -->
          <div v-if="topicContent.type_id == 2 || topicContent.type_id == 8">
            <p
              class="subject-info"
              v-html="topicContent.topic_sub[0].subinfo"
              style="margin-bottom: 12rem"
            ></p>
            <el-checkbox-group
              v-model="topicContent.topic_sub[0].user_answer"
              @change="$forceUpdate()"
            >
              <div v-for="(item, index) in topicContent.topic_sub[0].topic_answer" :key="index">
                <el-checkbox :label="item.answer_id">
                  <span v-html="item.ask"></span>
                </el-checkbox>
                <el-input
                  type="textarea"
                  :rows="8"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入更多内容"
                  style="font-size: 16rem"
                  v-if="item.is_other == 1"
                  v-model="topicContent.topic_sub[0].other_answer"
                  @input="$forceUpdate()"
                ></el-input>
              </div>
            </el-checkbox-group>
          </div>
          <!-- 多选题&不定项选择题 end -->
          <!-- 填空题 start -->
          <div v-if="topicContent.type_id == 3" class="flexel">
            <p
              class="subject-info"
              :class="topicContent.topic_sub[0].isExample ? 'subject-info-example' : ''"
              v-html="topicContent.topic_sub[0].subinfo"
            ></p>
            <div>
              <div
                v-for="(item, index) in topicContent.topic_sub[0].topic_answer"
                :key="index"
                style="
                  display: flex;
                  align-items: center;
                  margin-bottom: 10rem;
                "
              >
                <el-input
                  type="textarea"
                  :rows="8"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入答案"
                  style="font-size: 16rem"
                  v-if="item.textRadio == 1"
                  v-model="topicContent.topic_sub[0].brief_answer[index + 1]"
                  @input="$forceUpdate()"
                ></el-input>
                <div
                  v-if="
                    item.textRadio == 0 &&
                    (topicContent.topic_sub[0].answer_img[index + 1] || []).length
                  "
                  class="fill-img-box"
                >
                  <el-image
                    :src="topicContent.topic_sub[0].answer_img[index + 1][0]"
                    :preview-src-list="[
                      topicContent.topic_sub[0].answer_img[index + 1][0],
                    ]"
                    class="avatar"
                  ></el-image>
                  <i
                    class="el-icon-remove delect-icon-fill"
                    @click="delectFillImgClick(index + 1)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <!-- 填空题 end -->
          <!-- 简答题 start -->
          <div v-if="topicContent.type_id == 4">
            <p
              class="subject-info"
              :class="topicContent.topic_sub[0].isExample ? 'subject-info-example' : ''"
              v-html="topicContent.topic_sub[0].subinfo"
            ></p>
            <div
              v-if="anwserVisible"
              class="isTrue"
              :class="historyData && isTextAnwserTrue(historyData[topicContent.topic_sub[0].key], topicContent.topic_sub[0].answer) ? 'true-icon' : 'false-icon'"
            ></div>
            <el-input
              type="textarea"
              :rows="8"
              placeholder="请输入你的答案"
              v-model="topicContent.topic_sub[0].brief_answer[1]"
              maxlength="2000"
              show-word-limit
              @input="$forceUpdate()"
              :disabled="!!(historyData && historyData[topicContent.topic_sub[0].key])"
            >
            </el-input>
            <div style="display: flex; align-items: center; margin-top: 22rem" v-if="topicContent.topic_sub[0].is_upload">
              <div style="display: flex">
                <div
                  v-for="(item, index) in topicContent.topic_sub[0]
                    .answer_img[1]"
                  :key="index"
                  style="
                    width: 60rem;
                    height: 60rem;
                    margin-right: 20rem;
                    position: relative;
                  "
                >
                  <!-- 图片 start -->
                  <el-image
                    :src="item"
                    alt=""
                    style="width: 100%; height: 100%"
                    v-if="
                      item.split('.').pop() == 'jpg' ||
                      item.split('.').pop() == 'jpeg' ||
                      item.split('.').pop() == 'gif' ||
                      item.split('.').pop() == 'png'
                    "
                  >
                  </el-image>
                  <!-- 图片 end -->
                  <!-- zip start -->
                  <img
                    v-if="item.split('.').pop() == 'zip'"
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/zip.png')"
                    alt=""
                  />
                  <!-- zip end -->
                  <!-- rar start -->
                  <img
                    v-if="item.split('.').pop() == 'rar'"
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/rar.png')"
                    alt=""
                  />
                  <!-- rar end -->
                  <!-- mp3 start -->
                  <img
                    v-if="
                      item.split('.').pop() == 'mp3' ||
                      item.split('.').pop() == 'MP3'
                    "
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/mp3.png')"
                    alt=""
                  />
  
                  <!-- mp3 end -->
                  <!-- doc start -->
                  <img
                    v-if="
                      item.split('.').pop() == 'doc' ||
                      item.split('.').pop() == 'docx'
                    "
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/doc.png')"
                    alt=""
                  />
  
                  <!-- doc end -->
                  <!-- mp4 start -->
                  <img
                    v-if="item.split('.').pop() == 'mp4'"
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/mp4.png')"
                    alt=""
                  />
  
                  <!-- mp4 end -->
                  <!-- pdf start -->
                  <img
                    v-if="item.split('.').pop() == 'pdf'"
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/pdf.png')"
                    alt=""
                  />
                  <!-- ppt end -->
                  <!-- ppt start -->
                  <img
                    v-if="
                      item.split('.').pop() == 'ppt' ||
                      item.split('.').pop() == 'pptx'
                    "
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/ppt.png')"
                    alt=""
                  />
  
                  <!-- ppt end -->
                  <!-- xls start -->
                  <img
                    v-if="
                      item.split('.').pop() == 'xls' ||
                      item.split('.').pop() == 'xlsx'
                    "
                    class="file-icon"
                    :src="require('@/assets/images/bookContent/question/xls.png')"
                    alt=""
                  />
  
                  <!-- xls end -->
                  <i
                    class="el-icon-remove delect-icon"
                    @click="delectImgClick(index)"
                  ></i>
                </div>
              </div>
              <uploadFiles
                v-show="(topicContent.topic_sub[0].answer_img[1] || []).length < 5"
                :ref="`upload${topicContent}`"
                :getTokenParams="uploadGetTokenParams"
                :immediateUpload="true"
                :maxSize="15"
                allowedTypes=".jpg,.jpeg,.gif,.png"
                @uploadUrlChange="uploadUrlChange"
                @uploadClose="uploadClose"
              >
                <template v-slot:uploadView>
                  <div
                    @click="$refs[`upload${topicContent}`][0].uploadFilesHandle()"
                    style="
                      width: 60rem;
                      height: 60rem;
                      border: 1rem dashed #c0ccda;
                      border-radius: 6rem;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                  >
                    <i class="el-icon-plus" style="font-size: 28rem"></i>
                  </div>
                </template>
              </uploadFiles>
            </div>
            <p class="tips-p" v-if="topicContent.topic_sub[0].is_upload">
              <span>*</span>
              限制单个文件大小不超过15M，文件数量5个以内，支持格式jpg、jpeg、gif、png
            </p>
            <div class="anwser-box" v-if="anwserVisible">
              <div>参考答案：{{ anwserContent.concat_answer }}</div>
              <div v-html="anwserContent.subanalysis"></div>
            </div>
          </div>
          <!-- 简答题 end --> 
          <!-- 选词填空 start -->
          <div v-if="topicContent.type_id == 9">
            <p
              class="subject-info"
              v-html="topicContent.topic_sub[0].subinfo"
              style="margin-bottom: 12rem"
            ></p>
            <div
              v-for="(item, index) in topicContent.topic_sub[0].topic_answer"
              :key="index"
              class="xcflex"
            >
              <div
                class="blank-input"
                @click="textFocus($event, index)"
                :class="xciIndex == index ? 'xcActive' : ''"
                :title="topicContent.topic_sub[0].brief_answer[index + 1]"
              >
                {{ topicContent.topic_sub[0].brief_answer[index + 1] }}
              </div>
            </div>
            <div
              class="bg-question-box"
              v-if="topicContent.topic_sub[0].xciQuestionShow"
            >
              <el-radio-group
                v-model="
                  topicContent.topic_sub[0].brief_answer[temporaryIndex]
                "
                @input="$forceUpdate()"
                @change="
                  questionChange(
                    topicContent.topic_sub[0].brief_answer[temporaryIndex]
                  )
                "
              >
                <el-radio
                  v-for="(item, index) in topicContent.topic_sub[0].options"
                  :key="index"
                  :label="item"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <!-- 选词填空 end -->
          <!-- 组合题 start -->
          <div v-if="topicContent.type_id == 5">
            <div class="bg-question-box" ref="bgQuestion">
              <p v-html="topicContent.info"></p>
            </div>
            <!-- 小题题目切换区域 start -->
            <ul class="sub-question-tab">
              <li
                v-for="(item, index) in topicContent.topic_sub"
                :key="index"
                :topic-id="topicContent.topic_id"
                :sub-id="item.sub_id"
                class="sub-question-num"
                :ref="'sub' + topicContent.topic_id + '-' + item.sub_id"
                :class="[
                  subActiveId ==
                  'sub' + topicContent.topic_id + '-' + item.sub_id
                    ? 'subActive'
                    : '',
                ]"
                @click="subtabClick(topicContent.topic_id, item, index)"
              >
                <span>第{{ index + 1 }}题</span>
              </li>
            </ul>
            <!-- 小题题干区域 start -->
            <div>
              <!-- 单选题&判断题start -->
              <div
                v-if="
                  topicContent.topic_sub[subtabIndex].type_id == 1 ||
                  topicContent.topic_sub[subtabIndex].type_id == 7
                "
              >
                <p
                  v-html="topicContent.topic_sub[subtabIndex].subinfo"
                  style="margin-bottom: 12rem"
                ></p>
                <el-radio-group
                  v-model="topicContent.topic_sub[subtabIndex].user_answer"
                  @change="$forceUpdate()"
                >
                  <el-radio
                    :label="item.answer_id"
                    v-for="(item, index) in topicContent.topic_sub[subtabIndex]
                      .topic_answer"
                    :key="index"
                    ><span v-html="item.ask"></span
                  ></el-radio>
                </el-radio-group>
              </div>
              <!-- 单选题&判断题 end -->
              <!-- 多选题&不定项选择题 start -->
              <div
                v-if="
                  topicContent.topic_sub[subtabIndex].type_id == 2 ||
                  topicContent.topic_sub[subtabIndex].type_id == 8
                "
              >
                <p
                  v-html="topicContent.topic_sub[subtabIndex].subinfo"
                  style="margin-bottom: 12rem"
                ></p>
                <el-checkbox-group
                  v-model="topicContent.topic_sub[subtabIndex].user_answer"
                  @change="$forceUpdate()"
                >
                  <el-checkbox
                    :label="item.answer_id"
                    v-for="(item, index) in topicContent.topic_sub[subtabIndex]
                      .topic_answer"
                    :key="index"
                    ><span v-html="item.ask"></span
                  ></el-checkbox>
                </el-checkbox-group>
              </div>
              <!-- 多选题&不定项选择题 end -->
              <!-- 填空题 start -->
              <div
                v-if="topicContent.topic_sub[subtabIndex].type_id == 3"
                class="flexel"
              >
                <p
                  v-html="topicContent.topic_sub[subtabIndex].subinfo"
                  style="margin-bottom: 12rem"
                ></p>
                <div>
                  <div
                    v-for="(item, index) in topicContent.topic_sub[subtabIndex]
                      .topic_answer"
                    :key="index"
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 10rem;
                    "
                  >
                    <el-input
                      type="textarea"
                      :rows="8"
                      maxlength="500"
                      show-word-limit
                      placeholder="请输入答案"
                      style="font-size: 16rem"
                      v-if="item.textRadio == 1"
                      v-model="
                        topicContent.topic_sub[subtabIndex].brief_answer[
                          index + 1
                        ]
                      "
                      @input="$forceUpdate()"
                    ></el-input>
                    <div
                      v-if="
                        item.textRadio == 0 &&
                        (topicContent.topic_sub[subtabIndex].answer_img[
                          index + 1
                        ] || []).length
                      "
                      class="fill-img-box"
                    >
                      <el-image
                        :src="
                          topicContent.topic_sub[subtabIndex].answer_img[
                            index + 1
                          ][0]
                        "
                        :preview-src-list="[
                          topicContent.topic_sub[subtabIndex].answer_img[
                            index + 1
                          ][0],
                        ]"
                        class="avatar"
                      ></el-image>
                      <i
                        class="el-icon-remove delect-icon-fill"
                        @click="delectFillImgClick(index + 1, subtabIndex)"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 填空题 end -->
              <!-- 简答题 start -->
              <div v-if="topicContent.topic_sub[subtabIndex].type_id == 4">
                <p
                  v-html="topicContent.topic_sub[subtabIndex].subinfo"
                  style="margin-bottom: 12rem"
                ></p>
                <el-input
                  type="textarea"
                  :rows="12"
                  placeholder="请输入你的答案"
                  v-model="topicContent.topic_sub[subtabIndex].brief_answer[1]"
                  maxlength="2000"
                  show-word-limit
                  style="font-size: 16rem"
                  @input="$forceUpdate()"
                >
                </el-input>
                <div
                  style="display: flex; align-items: center; margin-top: 22rem"
                >
                  <div style="display: flex">
                    <div
                      v-for="(item, index) in topicContent.topic_sub[
                        subtabIndex
                      ].answer_img[1]"
                      :key="index"
                      style="
                        width: 60rem;
                        height: 60rem;
                        margin-right: 20rem;
                        position: relative;
                      "
                    >
                      <!-- 图片 start -->
                      <el-image
                        :src="item"
                        alt=""
                        style="width: 100%; height: 100%"
                        v-if="
                          item.split('.').pop() == 'jpg' ||
                          item.split('.').pop() == 'jpeg' ||
                          item.split('.').pop() == 'gif' ||
                          item.split('.').pop() == 'png'
                        "
                      >
                      </el-image>
                      <!-- 图片 end -->
                      <!-- zip start -->
                      <img
                        v-if="item.split('.').pop() == 'zip'"
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/zip.png')"
                        alt=""
                      />
  
                      <!-- zip end -->
                      <!-- rar start -->
                      <img
                        v-if="item.split('.').pop() == 'rar'"
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/rar.png')"
                        alt=""
                      />
  
                      <!-- rar end -->
                      <!-- mp3 start -->
                      <img
                        v-if="
                          item.split('.').pop() == 'mp3' ||
                          item.split('.').pop() == 'MP3'
                        "
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/mp3.png')"
                        alt=""
                      />
  
                      <!-- mp3 end -->
                      <!-- doc start -->
                      <img
                        v-if="
                          item.split('.').pop() == 'doc' ||
                          item.split('.').pop() == 'docx'
                        "
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/doc.png')"
                        alt=""
                      />
  
                      <!-- doc end -->
                      <!-- mp4 start -->
                      <img
                        v-if="item.split('.').pop() == 'mp4'"
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/mp4.png')"
                        alt=""
                      />
                      <!-- mp4 end -->
                      <!-- pdf start -->
                      <img
                        v-if="item.split('.').pop() == 'pdf'"
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/pdf.png')"
                        alt=""
                      />
  
                      <!-- ppt end -->
                      <!-- ppt start -->
                      <img
                        v-if="
                          item.split('.').pop() == 'ppt' ||
                          item.split('.').pop() == 'pptx'
                        "
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/ppt.png')"
                        alt=""
                      />
                      <!-- ppt end -->
                      <!-- xls start -->
                      <img
                        v-if="
                          item.split('.').pop() == 'xls' ||
                          item.split('.').pop() == 'xlsx'
                        "
                        class="file-icon"
                        :src="require('@/assets/images/bookContent/question/xls.png')"
                        alt=""
                      />
  
                      <!-- xls end -->
                      <i
                        class="el-icon-remove delect-icon"
                        @click="delectImgClick(index, subtabIndex)"
                      ></i>
                    </div>
                  </div>
                  <uploadFiles
                    :ref="`upload${topicContent}`"
                    :maxSize="15"
                    allowedTypes=".jpg,.jpeg,.gif,.png"
                    :getTokenParams="uploadGetTokenParams"
                    :immediateUpload="true"
                    @uploadUrlChange="uploadUrlChange"
                    @uploadClose="uploadClose"
                    v-show="
                      (topicContent.topic_sub[subtabIndex].answer_img[1] || [])
                        .length < 5
                    "
                  >
                    <template v-slot:uploadView>
                      <div
                        @click="$refs[`upload${topicContent}`][0].uploadFilesHandle()"
                        style="
                          width: 60rem;
                          height: 60rem;
                          border: 1rem dashed #c0ccda;
                          border-radius: 6rem;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          cursor: pointer;
                        "
                      >
                        <i class="el-icon-plus" style="font-size: 28rem"></i>
                      </div>
                    </template>
                  </uploadFiles>
                </div>
                <p class="tips-p">
                  <span>*</span>
                  限制单个文件大小不超过15M，文件数量5个以内，支持格式jpg、jpeg、gif、png
                </p>
              </div>
              <!-- 简答题 end -->
              <!-- 选词填空题 start -->
              <div v-if="topicContent.topic_sub[subtabIndex].type_id == 9">
                <p
                  v-html="topicContent.topic_sub[subtabIndex].subinfo"
                  style="margin-bottom: 12rem"
                ></p>
                <div
                  v-for="(item, index) in topicContent.topic_sub[subtabIndex]
                    .topic_answer"
                  :key="index"
                  class="xcflex"
                >
                  <div
                    @click="textFocus($event, index, 'zuheti')"
                    :class="xciIndex == index ? 'xcActive' : ''"
                    :title="
                      topicContent.topic_sub[subtabIndex].brief_answer[
                        index + 1
                      ]
                    "
                  >
                    {{
                      topicContent.topic_sub[subtabIndex].brief_answer[
                        index + 1
                      ]
                    }}
                  </div>
                </div>
                <div
                  class="bg-question-box"
                  v-if="topicContent.topic_sub[subtabIndex].xciQuestionShow"
                >
                  <el-radio-group
                    v-model="
                      topicContent.topic_sub[subtabIndex].brief_answer[
                        temporaryIndex
                      ]
                    "
                    @input="$forceUpdate()"
                    @change="
                      questionChange(
                        topicContent.topic_sub[subtabIndex].brief_answer[
                          temporaryIndex
                        ],
                        'zuheti'
                      )
                    "
                  >
                    <el-radio
                      v-for="(item, index) in topicContent.topic_sub[
                        subtabIndex
                      ].options"
                      :key="index"
                      :label="item"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </div>
              </div>
              <!-- 选词填空题 end -->
            </div>
            <!-- 小题题干区域 start -->
            <!-- 小题题目切换区域 end -->
          </div>
          <!-- 组合题 end -->
          <!-- 操作题 start -->
          <div v-if="topicContent.type_id == 6">
            <p
              class="subject-info"
              v-html="topicContent.topic_sub[0].subinfo"
              style="margin-bottom: 12rem"
            ></p>
          </div>
          <!-- 操作题 end -->
          <!-- 交互题 start -->
          <div v-if="topicContent.type_id == 10">
            <p
              v-if="topicContent.topic_sub[0].subinfo"
              class="subject-info"
              v-html="topicContent.topic_sub[0].subinfo"
              style="margin-bottom: 12rem"
            ></p>
            <actionIndex :content="topicContent.topic_sub[0].topic_content" @updateAnswer="actionUpdateAnswer($event, activeTopic)"></actionIndex>
          </div>
          <!-- 交互题 end -->
        </div>
      </div>
    </div>
    <div class="question-bottom">
      <span
        class="pre-btn bottom-btn"
        @click.stop="backClick()"
        :class="activeTopic === 0 ? 'backDisabled' : ''"
        >上一题</span
      ><span
        v-if="content.content[activeTopic].type_id == 1"
        class="submit switch-btn"
        :class="(!content.content[activeTopic].topic_sub[0].user_answer || (content.content[activeTopic].topic_sub[0].user_answer.length === 0) || (historyData && historyData[content.content[activeTopic].topic_sub[0].key])) ? 'submitDisabled' : ''"
        @click.stop="submitClick()"
        >提交</span
      ><span
        v-if="content.content[activeTopic].type_id == 4"
        class="submit switch-btn"
        :class="(!content.content[activeTopic].topic_sub[0].brief_answer[1] || (historyData && historyData[content.content[activeTopic].topic_sub[0].key])) ? 'submitDisabled' : ''"
        @click.stop="submitClick()"
        >提交</span
      ><span
        class="next-btn bottom-btn"
        @click.stop="nextClick()"
        :class="activeTopic == content.content.length - 1 ? 'backDisabled' : ''"
        >下一题</span
      >
    </div>
  </div>
</template>

<script>
/*
互动答题
*/
import actionIndex from "../action/index.vue";
import { getActionData, setActionData } from "@/utils/storage";
export default {
  name: "questionInteraction",
  components: {
    actionIndex,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      activeTopic: 0,
      anwserVisible: false,
      anwserContent: {},
      historyData: null,
    }
  },
  mounted() {
    this.historyData = (JSON.parse(getActionData()) || {});
    let historyData = this.historyData[this.content.content[this.activeTopic].topic_sub[0].key];
    if(historyData) {
      if(this.content.content[this.activeTopic].type_id == 1) {
        this.content.content[this.activeTopic].topic_sub[0].user_answer = historyData;
      }else if(this.content.content[this.activeTopic].type_id == 4) {
        this.content.content[this.activeTopic].topic_sub[0].brief_answer[1] = historyData;
      }
      this.anwserContent = this.content.content[this.activeTopic].topic_sub[0]
      this.$nextTick(() => {
        this.anwserVisible = true;
      })
    }
  },
  methods: {
    // 下一题
    nextClick() {
      if(this.activeTopic === this.content.content.length - 1) {
        return false;
      }
      this.activeTopic += 1;
      
      let historyData = this.historyData[this.content.content[this.activeTopic].topic_sub[0].key];
      if(historyData) {
        if(this.content.content[this.activeTopic].type_id == 1) {
          this.content.content[this.activeTopic].topic_sub[0].user_answer = historyData;
        }else if(this.content.content[this.activeTopic].type_id == 4) {
          this.content.content[this.activeTopic].topic_sub[0].brief_answer[1] = historyData;
        }
        this.anwserContent = this.content.content[this.activeTopic].topic_sub[0]
        this.anwserVisible = true;
      }else{
        this.anwserContent = {}
        this.anwserVisible = false;
      }
    },
    // 前一题
    backClick() {
      if(this.activeTopic === 0) {
        return false;
      }
      this.activeTopic -= 1;
      
      let historyData = this.historyData[this.content.content[this.activeTopic].topic_sub[0].key];
      if(historyData) {
        if(this.content.content[this.activeTopic].type_id == 1) {
          this.content.content[this.activeTopic].topic_sub[0].user_answer = historyData;
        }else if(this.content.content[this.activeTopic].type_id == 4) {
          this.content.content[this.activeTopic].topic_sub[0].brief_answer[1] = historyData;
        }
        this.anwserContent = this.content.content[this.activeTopic].topic_sub[0]
        this.anwserVisible = true;
      }else{
        this.anwserContent = {}
        this.anwserVisible = false;
      }
    },
    // 提交 显示参考答案
    submitClick() {
      let answerData = null;
      if(this.content.content[this.activeTopic].type_id == 1) {
        answerData = this.content.content[this.activeTopic].topic_sub[0].user_answer
      }else if(this.content.content[this.activeTopic].type_id == 4){
        answerData = this.content.content[this.activeTopic].topic_sub[0].brief_answer[1]
      }
      if(!answerData || answerData.length === 0) return false;
      this.anwserVisible = true;
      this.anwserContent = this.content.content[this.activeTopic].topic_sub[0]

      let historyData = {}
      historyData[this.content.content[this.activeTopic].topic_sub[0].key] = answerData
      this.historyData = Object.assign({}, this.historyData, historyData)
      setActionData(JSON.stringify(this.historyData));
    },
    changeHandle() {
      let answerData = this.content.content[this.activeTopic].topic_sub[0].user_answer

      this.$forceUpdate()
    },
    reset() {
      if(this.content.content[this.activeTopic].type_id == 1) {
        this.content.content[this.activeTopic].topic_sub[0].user_answer = '';
      }else if(this.content.content[this.activeTopic].type_id == 4) {
        this.content.content[this.activeTopic].topic_sub[0].brief_answer = {};
      }
      this.anwserContent = {}
      this.anwserVisible = false;

      delete this.historyData[this.content.content[this.activeTopic].topic_sub[0].key]
      setActionData(JSON.stringify(this.historyData));
    },
    // 简答题答案判断 所有答案关键字都必须拥有
    isTextAnwserTrue(answerText, trueText) {
      if(!answerText) return false
      let trueArr = trueText.split(',')
      let isTrue = true
      trueArr.forEach(item => {
        if(answerText.indexOf(item) < 0) {
          isTrue =false
        }
      });
      return isTrue
    },
    actionUpdateAnswer() {},
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-radio__label{
  display: inline-block;
}
.question-container{
  user-select: none;
  min-height: 480rem;
  display: flex;
  flex-direction: column;
  padding-bottom: 90rem;
  position: relative;
      
  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: -60rem;
    right: 40rem;
    cursor: pointer;
  }
  
  .question-content {
    flex: 1;
    overflow-y: auto;

    .question-top {
      position: relative;

      .question-top-title{
        padding: 0 27rem;
        font-size: 20rem;
        color: #333;
        font-weight: bold;
      }

      .question-top-info{
        padding: 0 27rem;
        font-size: 16rem;
        color: #999;
        margin-top: 5rem;
      }
    }

    .subject-info{
      font-size: 18rem;
      color: #333;
      margin-top: 20rem;
      line-height: 32rem;
      margin-bottom: 12rem;
    }

    .subject-info.subject-info-example{
      text-indent: 90rem;
      position: relative;
      margin-bottom: 20rem;

      &:before{
        content: '示例题';
        position: absolute;
        top: 0;
        left: 0;
        background: #DFF6EF;
        line-height: 32rem;
        height: 32rem;
        color: #23B08A;
        text-align: center;
        text-indent: 0;
        padding: 0 8rem;
        border-radius: 4rem;
      }
    }

    .answer-r-b-subjectC {
      padding: 0 22rem;
      position: relative;

      .true-active{

        /deep/.el-radio__label{
          // background: #DFF6EF;
        }
      }

      .isTrue{
        position: absolute;
        top: 40rem;
        right: 140rem;
        width: 28rem;
        height: 28rem;
      }

      .true-icon{
        background: url(~@/assets/images/books/bookExample/true-icon.png) center center no-repeat;
        background-size: contain;
      }

      .false-icon{
        background: url(~@/assets/images/books/bookExample/false-icon.png) center center no-repeat;
        background-size: contain;
      }
    }

    .anwser-box{
      font-size: 16rem;
      line-height: 24rem;
      border-top: 1rem dashed #999999;
      color: #333;
      margin-top: 10rem;

      div{
        margin-top: 10rem;

        &:first-child{
          margin-top: 20rem;
        }
      }
    }
  }

  .question-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5rem 50rem;
    background: #fff;
    border-top: 1rem solid #E3E3E3;

    span {
      width: 154rem;
      height: 48rem;
      line-height: 48rem;
      display: inline-block;
      text-align: center;
      font-size: 19rem;
      cursor: pointer;
    }

    .next-btn {
      margin-left: 12rem;
    }
    
    .submit {
      background: #F6A84C;
      color: #fff;
      width: 180px;
      height: 40rem;
      line-height: 40rem;
      border-radius: 4rem;
      font-size: 16rem;
      z-index: 1;
      cursor: pointer;
    }

    
    .bottom-btn{
      border: 0;
      font-size: 16rem;
      height: 40rem;
      line-height: 40rem;
      color: #333;
    }
    .submitDisabled{
      background: #f7c184;
      pointer-events: auto !important;
      cursor: not-allowed !important;
    }
    
    .backDisabled {
      opacity: 0.5;
      color: #999;
      pointer-events: auto !important;
      cursor: not-allowed !important;
    }
  }
}

/deep/.el-radio{
  display: block;
  margin-bottom: 15rem;
  padding-left: 20rem;
  color: #333;

  &:last-child{
    margin-bottom: 10rem;
  }

  .el-radio__label{
    margin-left: 5rem;
    padding: 5rem;
    font-size: 16rem;
  }
  .el-radio__input.is-checked .el-radio__inner{
    border-color: #0FC29A;
    background: #0FC29A;
  }
  .el-radio__input.is-checked+.el-radio__label{
    color: #606266;
  }
  .el-radio__inner:hover{
    border-color: #0FC29A;
  }
}
/deep/.el-textarea{
  font-size: 16rem;
  margin-bottom: 20rem;
  .el-input__count{
    bottom: 0;
  }
  .el-textarea__inner{
    height: 160rem;
    // border-color: #0FC29A;
  }
  .el-textarea__inner:focus{
    border-color: #0FC29A;
  }
}
.question-container-mobile{
  .question-content {
    padding-bottom: 180rem;
    .question-top {
      .question-top-title{
        font-size: 30rem;
        line-height: 56rem;
        margin-top: 20rem;
      }
      .question-top-info{
        font-size: 24rem;
        line-height: 38rem;
        margin-top: 5rem;
      }
      .reset{
        width: 44rem;
        height: 44rem;
      }
    }
    
    .subject-info{
      font-size: 28rem;
      line-height: 44rem;
    }

    .subject-info.subject-info-example{
      text-indent: 120rem;

      &:before{
        line-height: 44rem;
        height: 44rem;
        padding: 0 14rem;
      }
    }
    
    .answer-r-b-subjectC {
      .isTrue{
        width: 48rem;
        height: 138rem;
        right: 100rem;
      }
    }
    
    .anwser-box{
      font-size: 28rem;
      line-height: 48rem;
    }
  }

  .question-bottom {
    flex: 0 0 177rem;
    height: 177rem;
    padding: 40rem 24rem 0;
    border-top: 1rem solid #E3E3E3;
    align-items: start;

    span {
      width: 154rem;
      height: 78rem;
      line-height: 78rem;
      font-size: 28rem;
    }

    .next-btn {
      margin-left: 12rem;
    }
    
    .bottom-btn{
      font-size: 28rem;
      height: 78rem;
      line-height: 78rem;
    }
    
    .submit {
      width: 300rem;
      height: 78rem;
      line-height: 78rem;
      border-radius: 6rem;
      font-size: 28rem;
    }
  }
  
  /deep/.el-textarea{
    font-size: 28rem;
  }
  /deep/.el-radio{
    .el-radio__label{
    }
    .el-radio__label{
      margin-left: 10rem;
      padding: 10rem;
      font-size: 16rem;
      span{
        font-size: 28rem;
      }
    }
  }
}
</style>